import { useState } from 'react';
import { Check, Copy, Link2, Printer } from 'lucide-react';

export default function ResultActions({ t, summaryText, shareUrl }) {
  const [copied, setCopied] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);

  const copyResults = async () => {
    try {
      await navigator.clipboard.writeText(summaryText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable */
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch {
      /* clipboard unavailable */
    }
  };

  const printCard = () => {
    const w = window.open('', '_blank', 'width=480,height=640');
    if (!w) return;
    w.document.write(`
      <!DOCTYPE html><html><head><title>Size conversion</title>
      <style>body{font-family:system-ui,sans-serif;padding:24px;max-width:400px}
      h1{font-size:18px}pre{white-space:pre-wrap;font-size:14px;line-height:1.5}
      .note{color:#666;font-size:12px;margin-top:16px}</style></head><body>
      <h1>Pixel Utility — Size Converter</h1>
      <pre>${summaryText.replace(/</g, '&lt;')}</pre>
      <p class="note">Approximate sizes only. Check the brand size guide before buying.</p>
      </body></html>`);
    w.document.close();
    w.focus();
    w.print();
  };

  return (
    <div className="flex flex-wrap gap-2 mt-4">
      <button
        type="button"
        onClick={copyResults}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-600 bg-slate-800 px-4 py-2 text-sm text-slate-200 hover:border-emerald-600/50 transition-colors"
      >
        {copied ? <Check className="w-4 h-4 text-emerald-400" /> : <Copy className="w-4 h-4" />}
        {copied ? t.actions.copied : t.actions.copyResults}
      </button>
      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-600 bg-slate-800 px-4 py-2 text-sm text-slate-200 hover:border-emerald-600/50 transition-colors"
      >
        {linkCopied ? <Check className="w-4 h-4 text-emerald-400" /> : <Link2 className="w-4 h-4" />}
        {linkCopied ? t.actions.copied : t.actions.copyLink}
      </button>
      <button
        type="button"
        onClick={printCard}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-600 bg-slate-800 px-4 py-2 text-sm text-slate-200 hover:border-emerald-600/50 transition-colors"
      >
        <Printer className="w-4 h-4" />
        {t.actions.print}
      </button>
    </div>
  );
}
